var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTShirt = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentcolor",
  strokeWidth: 1.5,
  d: "M10.47 2 15 3.708v3.528l-2.897-.705v6.98H3.971v-6.98L1 7.236V3.708L5.605 2m4.864 0H5.606m4.864 0c-.037.978-.512 2.562-2.413 2.562-1.902 0-2.377-1.584-2.451-2.562"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTShirt);
export default ForwardRef;